<template>
  <div class="layout">
    <div class="frist-div">
      <div class="layout-cardcount">
        <CardHeadCount :series="totalHeadCount" />
        <CardHeadManhour :series="totalHeadManhour" />
      </div>
      <CardOvertime />
    </div>
    <div class="second-div" v-if="delay == 1">
      <vue-horizontal-list :items="HorizontalList" :options="options">
        <template v-slot:default="{ item }">
          <Cardlist :item="item" />
        </template>
      </vue-horizontal-list>
    </div>
    <div class="third-div">
      <WorkforceStatus />
    </div>
  </div>
</template>

<script>
import DonutChart from "@/components/ApexChart/DonutChart.vue";
import CardHeadCount from "./components/CardHeadCount.vue";
import CardHeadManhour from "./components/CardHeadManhour.vue";
import CardOvertime from "./components/CardOvertime.vue";
import WorkforceStatus from "./components/WorkforceStatus.vue";
import VueHorizontalList from "vue-horizontal-list";
import Cardlist from "./components/Cardlist.vue";

export default {
  components: {
    DonutChart,
    CardHeadCount,
    CardHeadManhour,
    CardOvertime,
    WorkforceStatus,
    VueHorizontalList,
    Cardlist,
  },
  data() {
    return {
      delay: 0,
      totalHeadCount: [44, 2],
      totalHeadManhour: [340, 28],
      HorizontalList: [
        {
          name: "Sentennce",
          logo: require("@/assets/images/logo/sentenance_logo.png"),
          subName: "Department",
          img: require("@/assets/images/gif/1.gif"),
          data: [10, 0],
          color: ["#32C040", "#b1fab8"],
        },
        {
          name: "Sentennce",
          logo: require("@/assets/images/sentenance/sar_logo_1.png"),
          subName: "Department",
          img: require("@/assets/images/gif/2.gif"),
          data: [20, 2],
          color: ["#fea30a", "#ffebc6"],
        },
        {
          name: "Accounting",
          logo: "",
          subName: "Department",
          img: require("@/assets/images/gif/3.gif"),
          data: [2, 1],
          color: ["#fad151", "#fcf4ac"],
        },
        {
          name: "Meeting Room 1",
          logo: "",
          subName: "",
          img: require("@/assets/images/gif/4.gif"),
          data: [4, 1],
          color: ["#c86c85", "#f4c8ec"],
        },
        {
          name: "Meeting Room 2",
          logo: "",
          subName: "",
          img: require("@/assets/images/gif/5.gif"),
          data: [2, 2],
          color: ["#9017d4", "#e4c8f4"],
        },
      ],
      options: {
        responsive: [
          { end: 576, size: 1.2 },
          { start: 576, end: 768, size: 2 },
          { start: 768, end: 1200, size: 3 },
          { size: 4.5 },
        ],
        item: {
          // css class to inject into each individual item
          class: "item-horizontal-list",
          // padding between each item
          padding: 12,
        },
        list: {
          // 1200 because @media (min-width: 1200px) and therefore I want to switch to windowed mode
          windowed: 1200,

          // padding of the list, if container < windowed what is the left-right padding of the list
          // during full-screen mode the padding will added to left & right to centralise the item
          // Because: #app {padding: 80px 24px;}
          padding: 12,
        },
        position: {
          start: 0,
        },
        // autoplay: { play: true, repeat: true, speed: 2500 },
      },

      series: [44, 2],
      chartOptions: {
        chart: {
          type: "donut",
        },
        labels: ["Active", "Inactive"],
        colors: ["#f7b459", "#f8e0a4"],
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },

        // responsive: [
        //   {
        //     breakpoint: 480,
        //     options: {
        //       chart: {
        //         width: 100,
        //       },
        //       dataLabels: {
        //         enabled: true,
        //       },
        //     },
        //   },
        // ],
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.delay = 1;
    }, 100);
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  gap: 10px;
  // color: #b1fab8;
}

.frist-div {
  display: grid;
  grid: auto/30% auto;
  width: 100%;
  gap: 10px;
  .layout-cardcount {
    display: flex;
    gap: 10px;
    flex-direction: column;
  }
}
.second-div {
  height: 260px;
}

@media only screen and (max-width: 508px) {
  .frist-div {
  display: grid;
  grid: auto auto/ auto;
  width: 100%;
  gap: 10px;
}
}
</style>